import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import {useTranslation} from 'react-i18next';
import AgyleButton from '../../components/ui/buttons/agyleButton';
import {AgyleLogoIcon} from '../../components/icons/icons';
import {useHistory} from 'react-router-dom';

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        flexWrap: 'nowrap',
        height: '100vh',
        width: '100vw',
        color: '#000',
        backgroundColor: '#fff',
        fontWeight: 600,
        gap: 10,
    },
    logo: {
        fontSize: 124,
    },
    opps: {
        fontSize: 48,
    },
    title: {
        fontSize: 24,
    },
    message: {
        fontSize: 14,
    },
}));

const Page404 = () => {
    const classes = useStyles();
    const {t} = useTranslation();
    const history = useHistory();

    const handleGoBack = () => {
        history.push('/');
    };

    return (
        <div className={classes.root}>
            <AgyleLogoIcon className={classes.logo}/>

            <div className={classes.opps}>
                Oops!
            </div>

            <div className={classes.title}>
                404 - Page not found
            </div>

            <div className={classes.message}>
                {t('error404.message')}
            </div>

            <AgyleButton
                variant="contained"
                onClick={handleGoBack}
            >
                {t('error404.button')}
            </AgyleButton>
        </div>
    );
};

export default Page404;